/* global window */
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

// ACTIONS
import { getUser } from 'Actions/users';
import setLoginModalState from 'Actions/setLoginModalState';

// REDUCERS
import { urls as urlsItems } from 'Reducers/items';

// SELECTORS
import { userSelector } from 'Selectors/users';
import { itemSelector } from 'Selectors/items';

// OTHERS
import Auth from '../../../../Auth';
import { get } from 'Server';

const WhatsappContainer = ({
    children, phone, userData, getItemPhone, setLoginModalState, getUser, item, track, intl
}) => {
    const [isFetchingPhone, setFetchingPhone] = useState(false);
    const [shouldTriggerCall, setTriggerCall] = useState(false);
    const [isCalledTriggered, setCallTriggered] = useState(false);

    const trackWhatsappClick = eventName => track(eventName, {
        seller_id: userData.id
    });

    const handleClickCall = () => {
        if (phone) {
            setTriggerCall(false);
            trackWhatsappClick('item_tap_whatsapp_clicked');
            const profileName = userData.name;
            const adTitle = item.title;
            const formattedPhone = phone.replace(/\D/g, '');
            const formaettedMessage = encodeURIComponent(intl.formatMessage({ id: 'whatsAppMessagePremium' }, { adTitle, profileName }));

            window.open(`https://wa.me/${formattedPhone}?text=${formaettedMessage}\n ${window.location.href}`, '_blank');
        }
    };

    useEffect(() => {
        if (phone && shouldTriggerCall && !isCalledTriggered) {
            setCallTriggered(true);
            handleClickCall();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldTriggerCall, isCalledTriggered, phone]);

    const requestPhoneForWhatsapp = async params => {
        trackWhatsappClick('item_intent_whatsapp');
        if (Auth.isLoggedIn()) {
            setFetchingPhone(true);

            try {
                if (item.has_phone_param) {
                    await getItemPhone(item.id);
                }
                else {
                    await getUser(userData.id, params);
                }
                setFetchingPhone(false);
                setTriggerCall(true);
            }
            catch (error) {
                setFetchingPhone(false);
            }
            return null;
        }
        setLoginModalState({
            state: true,
            redirectTo: '',
            entryPoint: 0,
            callback: () => requestPhoneForWhatsapp()
        });
        return null;
    };

    return children({
        clickHandler: handleClickCall,
        requestPhoneForWhatsapp,
        phone,
        isFetchingPhone
    });
};

WhatsappContainer.propTypes = {
    phone: PropTypes.string,
    userData: PropTypes.object,
    getUser: PropTypes.func,
    getItemPhone: PropTypes.func,
    setLoginModalState: PropTypes.func,
    item: PropTypes.object,
    track: PropTypes.func,
    intl: PropTypes.object
};

const mstp = (state, { userId, itemId }) => {
    const item = itemSelector(state, { params: { id: itemId }});
    const userData = userSelector(state, userId);

    return {
        phone: item.has_phone_param ? item.ad_phone : userData.phone,
        userData,
        item
    };
};

const mdtp = dispatch => ({
    getUser: (userId, params) => dispatch(getUser(userId, true, params)),
    getItemPhone: itemId => dispatch(get(urlsItems.getItemPhone(itemId), 'ELEMENT_ITEMS')),
    setLoginModalState: state => dispatch(setLoginModalState(state))
});

export default compose(
    connect(mstp, mdtp),
    injectIntl
)(WhatsappContainer);
